import { render, staticRenderFns } from "./TeamBuildingSection.vue?vue&type=template&id=df775e74&scoped=true&"
import script from "./TeamBuildingSection.vue?vue&type=script&lang=js&"
export * from "./TeamBuildingSection.vue?vue&type=script&lang=js&"
import style0 from "./TeamBuildingSection.vue?vue&type=style&index=0&id=df775e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df775e74",
  null
  
)

export default component.exports